import { isArray } from '@ember/array';

const isMetadata = value =>
  typeof value === 'string' && value.toLowerCase() === 'metadata';

export const sortByType = (a, b) =>
  a.typeId === b.typeId ? 0 : (a.typeId > b.typeId && !isMetadata(b.typeId)) ? 1 : -1;

export default function groupItemModels(items) {
  const ordered = [];
  const byTypeId = {};
  if (isArray(items)) {
    items.forEach(item => {
      let type = byTypeId[item.typeId];
      if (!type) {
        type = {
          typeId: item.typeId,
          type:   item.type,
          items:  [],
        };
        ordered.push(type);
        byTypeId[item.typeId] = type;
      }
      type.items.push(item);
    });
  }
  return {
    ordered: ordered.sort(sortByType),
    byTypeId: byTypeId,
  };
}
